import { render, staticRenderFns } from "./AppSoftKioskSetting.vue?vue&type=template&id=040ae3b0&scoped=true"
import script from "./AppSoftKioskSetting.vue?vue&type=script&lang=js"
export * from "./AppSoftKioskSetting.vue?vue&type=script&lang=js"
import style0 from "./AppSoftKioskSetting.vue?vue&type=style&index=0&id=040ae3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ae3b0",
  null
  
)

export default component.exports